import { HOMEPAGE_TAB_MENU_LIST } from '@constants/constants';
import { ServiceType } from '@shared/searchBar';

export const getServiceId = (key: ServiceType) =>
  HOMEPAGE_TAB_MENU_LIST.find((item) => item?.key === key)?.id || 1;
